import type {AxiosRequestConfig, AxiosResponse} from 'axios';
import type {ErrorsType} from 'api/generated';
import {produce, type Draft} from 'immer';
import {queryClient} from 'App';

type ResponseType<T> = {
  data: T | T[];
  errors: ErrorsType;
};

type ApiType<T> = (params: any, options?: AxiosRequestConfig) => Promise<AxiosResponse<ResponseType<T>>>;

interface ICacheUpdateItemProps<T> {
  queryKey: readonly any[];
  data: Draft<T>;
  remove?: boolean;
}

const cacheUpdateItem = <T extends {uid: string}>({queryKey, data, remove = false}: ICacheUpdateItemProps<T>) => {
  queryClient.setQueriesData({queryKey}, (old: Awaited<ReturnType<ApiType<T>>>) => {
    if (!old?.data?.data) {
      return old;
    }
    if (Array.isArray(old.data.data)) {
      return produce(old, draft => {
        const draftData = draft.data.data as Draft<T[]>;
        const index = draftData.findIndex(d => d.uid === data.uid);
        if (index !== -1) {
          if (remove) {
            draftData.splice(index, 1);
          } else {
            draftData.splice(index, 1, data);
          }
        }
      });
    } else {
      return produce(old, draft => {
        draft.data.data = data;
      });
    }
  });
};

export default cacheUpdateItem;
